import { useState } from 'react';
import { twMerge } from 'tailwind-merge';

export default function ImageCircularAvatar({
  imageUrl,
  customClass,
  fallbackImg,
  fallbackText,
  clicked,
}: {
  imageUrl: string;
  customClass?: string;
  fallbackImg?: string;
  fallbackText?: string;
  clicked?: () => void;
}) {
  const [isImageLoadError, setIsImageLoadError] = useState(false);

  const renderFallBack = () => {
    if (fallbackImg) {
      return (
        <img
          className={twMerge(['h-10 w-10 rounded-full', customClass])}
          src={fallbackImg}
          alt='fallback-avatar'
          onClick={clicked}
          title={fallbackText}
        />
      );
    }

    if (fallbackText) {
      return (
        <div
          className={twMerge([
            'h-10 w-10 bg-gray-200 rounded-full flex justify-center items-center text-md p-2 text-primaryColor-normal font-bold tracking-wider',
            customClass,
          ])}
          onClick={clicked}
        >
          {fallbackText}
        </div>
      );
    }
  };

  return (
    <>
      {!isImageLoadError && imageUrl !== null && imageUrl && (
        <img
          className={twMerge(['h-10 w-10 rounded-full', customClass])}
          src={imageUrl}
          alt='avatar'
          onError={() => setIsImageLoadError(true)}
          onClick={clicked}
        />
      )}
      {(isImageLoadError || imageUrl === null || !imageUrl) && renderFallBack()}
    </>
  );
}
